import React from "react";
import SVG from "react-inlinesvg";
import styles from "./TabHeader.module.scss"
import { Heading, Text } from "../..";

export default ({ logo, Icon, label, children }) => {
    return <header className={styles.base}>
        {<div className={styles["service"]}>
            {logo && <SVG src={logo} />}
            {Icon && <Icon />}
            <Heading level={20} color="text-title">{label}</Heading>
        </div>}
        {typeof (children) === 'string' ? <Text>{children}</Text> : children}
    </header>
};
